export default __webpack_public_path__ + "static/media/logo.46793fe6.svg";